/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionHexLink2FragmentDoc } from "../../../hex-list-2/HexList2.generated";
import { CollectionForEditDialogFragmentDoc } from "../dialogs/EditCollectionDialog.generated";
import { AddToCollectionDialogFragmentDoc } from "../dialogs/AddToCollectionDialog.generated";
import { DeleteCollectionDialogFragmentDoc } from "../dialogs/DeleteCollectionDialog.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectionWithHexes2Fragment = {
  readonly __typename: "Collection";
  readonly id: c.CollectionId;
  readonly canManage: boolean;
  readonly starredByViewer: boolean;
  readonly emoji: string | null;
  readonly description: string | null;
  readonly name: string;
  readonly collectionHexLinks: ReadonlyArray<{
    readonly __typename: "CollectionHexLink";
    readonly id: c.CollectionHexLinkId;
    readonly projectRole: Types.ProjectRole | null;
    readonly safeOrUnknownHex:
      | {
          readonly __typename: "Hex";
          readonly id: c.HexId;
          readonly title: string;
          readonly description: c.RichTextDocument | null;
          readonly canShare: boolean;
          readonly canSetOwner: boolean;
          readonly maxGrantableRole: Types.ProjectRole | null;
          readonly canViewLogic: boolean;
          readonly effectiveRole: Types.ProjectRole | null;
          readonly trashDate: c.DateTimeString | null;
          readonly starredByViewer: boolean;
          readonly userUpdatedDate: c.DateTimeString;
          readonly hexType: Types.HexType;
          readonly lastViewedByMe: c.DateTimeString | null;
          readonly requiresReview: boolean;
          readonly resolvedRequiresReview: boolean;
          readonly hasEnabledSchedules: boolean;
          readonly allowEmbedding: boolean;
          readonly canDelete: boolean;
          readonly canEditMetadata: boolean;
          readonly canUseApp: boolean;
          readonly projectLanguage: Types.ProjectLanguage;
          readonly canEdit: boolean;
          readonly canEditorsShare: boolean;
          readonly archivedDate: c.DateTimeString | null;
          readonly unarchivedDate: c.DateTimeString | null;
          readonly publicRoleV2: Types.ProjectRole | null;
          readonly organizationRoleV2: Types.ProjectRole | null;
          readonly grantSummary: c.ProjectGrantSummary;
          readonly onlyGrantedToCurrentUser: boolean;
          readonly totalViewCount: number;
          readonly dateCreated: c.DateTimeString;
          readonly status: {
            readonly __typename: "Status";
            readonly enforcesReview: boolean;
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
          readonly categories: ReadonlyArray<{
            readonly __typename: "Category";
            readonly id: c.CategoryId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
          }>;
          readonly lastPublishedVersion: {
            readonly __typename: "HexVersion";
            readonly id: c.HexVersionId;
            readonly screenshotUrls: c.ScreenshotUrls | null;
            readonly dateCreated: c.DateTimeString;
            readonly denialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
          } | null;
          readonly currentDraft: {
            readonly __typename: "HexVersion";
            readonly createdDate: c.DateTimeString;
            readonly id: c.HexVersionId;
            readonly title: string;
            readonly logicSessionId: c.AppSessionId;
            readonly canEdit: boolean;
            readonly kernelImage: c.KernelImage;
            readonly kernelSize: c.KernelSize;
            readonly kernelSizeHumanName: string | null;
            readonly kernelImageHumanName: string | null;
            readonly oAuthSettings: {
              readonly __typename: "HexVersionOAuthSettings";
              readonly id: c.HexVersionOAuthSettingsId;
              readonly logicViewTokenShared: boolean;
            } | null;
            readonly denialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
          };
          readonly owner: {
            readonly __typename: "User";
            readonly id: c.UserId;
            readonly name: string | null;
            readonly email: string;
            readonly imageUrl?: string | null;
          };
          readonly creator: {
            readonly __typename: "User";
            readonly id: c.UserId;
            readonly name: string | null;
            readonly email: string;
            readonly imageUrl?: string | null;
          };
          readonly collectionHexLink: {
            readonly __typename: "CollectionHexLink";
            readonly id: c.CollectionHexLinkId;
            readonly projectRole: Types.ProjectRole | null;
            readonly collection: {
              readonly __typename: "Collection";
              readonly id: c.CollectionId;
            };
          } | null;
          readonly safeCollectionHexLinks: ReadonlyArray<{
            readonly __typename: "CollectionHexLink";
            readonly id: c.CollectionHexLinkId;
            readonly collection: {
              readonly __typename: "Collection";
              readonly id: c.CollectionId;
              readonly name: string;
              readonly emoji: string | null;
            };
          }>;
          readonly org: {
            readonly __typename: "Org";
            readonly id: c.OrgId;
            readonly displayName: string;
            readonly allowPublicSharing: boolean;
            readonly resolvedAllowPublicSharing: boolean;
          };
          readonly projectAnalytics: {
            readonly __typename: "HexAnalytics";
            readonly id: c.HexAnalyticsId;
            readonly totalViewsLast7Days: number;
            readonly totalViewsLast14Days: number;
            readonly totalViewsLast30Days: number;
            readonly lastPublishedViewedDate: c.DateTimeString | null;
          };
        }
      | {
          readonly __typename: "UnknownHex";
          readonly id: c.HexId;
          readonly userUpdatedDate: c.DateTimeString;
          readonly hexType: Types.HexType;
          readonly creator: {
            readonly __typename: "User";
            readonly id: c.UserId;
            readonly name: string | null;
            readonly email: string;
          };
          readonly owner: {
            readonly __typename: "User";
            readonly id: c.UserId;
            readonly name: string | null;
            readonly email: string;
          };
        };
    readonly collection: {
      readonly __typename: "Collection";
      readonly id: c.CollectionId;
    };
  }>;
  readonly collectionGrants: ReadonlyArray<{
    readonly __typename: "CollectionGrant";
    readonly id: c.CollectionGrantId;
    readonly role: Types.CollectionRole;
    readonly holder:
      | {
          readonly __typename: "Group";
          readonly groupId: c.GroupId;
          readonly groupName: string;
        }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        }
      | {
          readonly __typename: "User";
          readonly name: string | null;
          readonly email: string;
          readonly active: boolean;
          readonly imageUrl: string | null;
          readonly orgRole: Types.OrgRole;
          readonly userId: c.UserId;
        };
  }>;
};

export type GetCollectionForShowTab2QueryVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  includeCreatorImgUrl?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type GetCollectionForShowTab2Query = {
  readonly __typename: "Query";
  readonly collectionById: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly canManage: boolean;
    readonly starredByViewer: boolean;
    readonly emoji: string | null;
    readonly description: string | null;
    readonly name: string;
    readonly collectionHexLinks: ReadonlyArray<{
      readonly __typename: "CollectionHexLink";
      readonly id: c.CollectionHexLinkId;
      readonly projectRole: Types.ProjectRole | null;
      readonly safeOrUnknownHex:
        | {
            readonly __typename: "Hex";
            readonly id: c.HexId;
            readonly title: string;
            readonly description: c.RichTextDocument | null;
            readonly canShare: boolean;
            readonly canSetOwner: boolean;
            readonly maxGrantableRole: Types.ProjectRole | null;
            readonly canViewLogic: boolean;
            readonly effectiveRole: Types.ProjectRole | null;
            readonly trashDate: c.DateTimeString | null;
            readonly starredByViewer: boolean;
            readonly userUpdatedDate: c.DateTimeString;
            readonly hexType: Types.HexType;
            readonly lastViewedByMe: c.DateTimeString | null;
            readonly requiresReview: boolean;
            readonly resolvedRequiresReview: boolean;
            readonly hasEnabledSchedules: boolean;
            readonly allowEmbedding: boolean;
            readonly canDelete: boolean;
            readonly canEditMetadata: boolean;
            readonly canUseApp: boolean;
            readonly projectLanguage: Types.ProjectLanguage;
            readonly canEdit: boolean;
            readonly canEditorsShare: boolean;
            readonly archivedDate: c.DateTimeString | null;
            readonly unarchivedDate: c.DateTimeString | null;
            readonly publicRoleV2: Types.ProjectRole | null;
            readonly organizationRoleV2: Types.ProjectRole | null;
            readonly grantSummary: c.ProjectGrantSummary;
            readonly onlyGrantedToCurrentUser: boolean;
            readonly totalViewCount: number;
            readonly dateCreated: c.DateTimeString;
            readonly status: {
              readonly __typename: "Status";
              readonly enforcesReview: boolean;
              readonly id: c.StatusId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
              readonly inLibrary: boolean;
              readonly endorsed: boolean;
              readonly icon: Types.IconType | null;
            } | null;
            readonly categories: ReadonlyArray<{
              readonly __typename: "Category";
              readonly id: c.CategoryId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
            }>;
            readonly lastPublishedVersion: {
              readonly __typename: "HexVersion";
              readonly id: c.HexVersionId;
              readonly screenshotUrls: c.ScreenshotUrls | null;
              readonly dateCreated: c.DateTimeString;
              readonly denialReason:
                | {
                    readonly __typename: "AssetAccess";
                    readonly hasAccessToSharedDataConnections: boolean;
                    readonly hasAccessToSharedFiles: boolean;
                    readonly hasAccessToSharedPackages: boolean;
                    readonly hasAccessToSharedSecrets: boolean;
                    readonly hasAccessToSharedSyncRepositories: boolean;
                  }
                | { readonly __typename: "MissingProjectRole" }
                | null;
            } | null;
            readonly currentDraft: {
              readonly __typename: "HexVersion";
              readonly createdDate: c.DateTimeString;
              readonly id: c.HexVersionId;
              readonly title: string;
              readonly logicSessionId: c.AppSessionId;
              readonly canEdit: boolean;
              readonly kernelImage: c.KernelImage;
              readonly kernelSize: c.KernelSize;
              readonly kernelSizeHumanName: string | null;
              readonly kernelImageHumanName: string | null;
              readonly oAuthSettings: {
                readonly __typename: "HexVersionOAuthSettings";
                readonly id: c.HexVersionOAuthSettingsId;
                readonly logicViewTokenShared: boolean;
              } | null;
              readonly denialReason:
                | {
                    readonly __typename: "AssetAccess";
                    readonly hasAccessToSharedDataConnections: boolean;
                    readonly hasAccessToSharedFiles: boolean;
                    readonly hasAccessToSharedPackages: boolean;
                    readonly hasAccessToSharedSecrets: boolean;
                    readonly hasAccessToSharedSyncRepositories: boolean;
                  }
                | { readonly __typename: "MissingProjectRole" }
                | null;
            };
            readonly owner: {
              readonly __typename: "User";
              readonly id: c.UserId;
              readonly name: string | null;
              readonly email: string;
              readonly imageUrl?: string | null;
            };
            readonly creator: {
              readonly __typename: "User";
              readonly id: c.UserId;
              readonly name: string | null;
              readonly email: string;
              readonly imageUrl?: string | null;
            };
            readonly collectionHexLink: {
              readonly __typename: "CollectionHexLink";
              readonly id: c.CollectionHexLinkId;
              readonly projectRole: Types.ProjectRole | null;
              readonly collection: {
                readonly __typename: "Collection";
                readonly id: c.CollectionId;
              };
            } | null;
            readonly safeCollectionHexLinks: ReadonlyArray<{
              readonly __typename: "CollectionHexLink";
              readonly id: c.CollectionHexLinkId;
              readonly collection: {
                readonly __typename: "Collection";
                readonly id: c.CollectionId;
                readonly name: string;
                readonly emoji: string | null;
              };
            }>;
            readonly org: {
              readonly __typename: "Org";
              readonly id: c.OrgId;
              readonly displayName: string;
              readonly allowPublicSharing: boolean;
              readonly resolvedAllowPublicSharing: boolean;
            };
            readonly projectAnalytics: {
              readonly __typename: "HexAnalytics";
              readonly id: c.HexAnalyticsId;
              readonly totalViewsLast7Days: number;
              readonly totalViewsLast14Days: number;
              readonly totalViewsLast30Days: number;
              readonly lastPublishedViewedDate: c.DateTimeString | null;
            };
          }
        | {
            readonly __typename: "UnknownHex";
            readonly id: c.HexId;
            readonly userUpdatedDate: c.DateTimeString;
            readonly hexType: Types.HexType;
            readonly creator: {
              readonly __typename: "User";
              readonly id: c.UserId;
              readonly name: string | null;
              readonly email: string;
            };
            readonly owner: {
              readonly __typename: "User";
              readonly id: c.UserId;
              readonly name: string | null;
              readonly email: string;
            };
          };
      readonly collection: {
        readonly __typename: "Collection";
        readonly id: c.CollectionId;
      };
    }>;
    readonly collectionGrants: ReadonlyArray<{
      readonly __typename: "CollectionGrant";
      readonly id: c.CollectionGrantId;
      readonly role: Types.CollectionRole;
      readonly holder:
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
          };
    }>;
  };
};

export const CollectionWithHexes2FragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionWithHexes2Fragment on Collection {
    id
    canManage
    collectionHexLinks {
      ...CollectionHexLink2Fragment
    }
    starredByViewer
    ...CollectionForEditDialogFragment
    ...AddToCollectionDialogFragment
    ...DeleteCollectionDialogFragment
  }
  ${CollectionHexLink2FragmentDoc}
  ${CollectionForEditDialogFragmentDoc}
  ${AddToCollectionDialogFragmentDoc}
  ${DeleteCollectionDialogFragmentDoc}
`;
export const GetCollectionForShowTab2Document = /*#__PURE__*/ gql`
  query GetCollectionForShowTab2(
    $collectionId: CollectionId!
    $includeCreatorImgUrl: Boolean = false
  ) {
    collectionById(collectionId: $collectionId) {
      id
      ...CollectionWithHexes2Fragment
    }
  }
  ${CollectionWithHexes2FragmentDoc}
`;

/**
 * __useGetCollectionForShowTab2Query__
 *
 * To run a query within a React component, call `useGetCollectionForShowTab2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForShowTab2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForShowTab2Query({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      includeCreatorImgUrl: // value for 'includeCreatorImgUrl'
 *   },
 * });
 */
export function useGetCollectionForShowTab2Query(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionForShowTab2Query,
    GetCollectionForShowTab2QueryVariables
  > &
    (
      | { variables: GetCollectionForShowTab2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionForShowTab2Query,
    GetCollectionForShowTab2QueryVariables
  >(GetCollectionForShowTab2Document, options);
}
export function useGetCollectionForShowTab2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionForShowTab2Query,
    GetCollectionForShowTab2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionForShowTab2Query,
    GetCollectionForShowTab2QueryVariables
  >(GetCollectionForShowTab2Document, options);
}
export function useGetCollectionForShowTab2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCollectionForShowTab2Query,
    GetCollectionForShowTab2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCollectionForShowTab2Query,
    GetCollectionForShowTab2QueryVariables
  >(GetCollectionForShowTab2Document, options);
}
export type GetCollectionForShowTab2QueryHookResult = ReturnType<
  typeof useGetCollectionForShowTab2Query
>;
export type GetCollectionForShowTab2LazyQueryHookResult = ReturnType<
  typeof useGetCollectionForShowTab2LazyQuery
>;
export type GetCollectionForShowTab2SuspenseQueryHookResult = ReturnType<
  typeof useGetCollectionForShowTab2SuspenseQuery
>;
export type GetCollectionForShowTab2QueryResult = Apollo.QueryResult<
  GetCollectionForShowTab2Query,
  GetCollectionForShowTab2QueryVariables
>;
